import TeamCarousel from './team-carousel';

export default TeamCarousel;
